import { Apis } from "../../../../lib/Apis";

export async function getProductById(id) {
  const response = await Apis.getProductById(id);
  return response?.data?.data || response?.data;
}

/** @deprecated Prefer importing getProductById directly */
export const productsHook = () => ({
  getProductById,
});
